module.exports = "<app-t2-card class=\"card-modal-w-50\" #modalUsersDelete [modal]=\"true\" title=\"Delete User\">\r\n  <form class=\"form\" #modalForm=\"ngForm\">\r\n    <h5>Are you sure you want to permanently disable the selected element?</h5>\r\n    <footer class=\"container-btns\">\r\n      <button type=\"button\" class=\"m-btn m-btn-default\" [disabled]=\"!modalForm.valid\" (click)=\"saveAction()\">Yes</button>\r\n      <button type=\"button\" class=\"m-btn m-btn-primary\" (click)=\"modalUsersDelete.close()\">No</button>\r\n    </footer>\r\n  </form>\r\n</app-t2-card>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/users/delete/delete.component.html
// module id = 2567
// module chunks = 66